import { Box, Chip, Divider, Tooltip, Typography } from '@mui/material';
import { paths } from '@common/types';
import { Check, Warning } from '@mui/icons-material';
import dayjs from 'dayjs';
import { theme } from '@store';

interface IHistoryProps {
  history: paths[`/program/{program_id}/{patient_id}/status-history`]['get']['responses']['200']['content']['application/json']['status_history'];
}

export const History = ({ history }: IHistoryProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      {history.length === 0 ? (
        <Typography
          variant='body1'
          sx={{ color: theme => theme.palette.semiBlack.main }}
        >
          No history available yet.
        </Typography>
      ) : (
        history.map((entry, index) => {
          return (
            <Box
              sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
              key={`${entry.status_name} + ${index}`}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  gap: '1rem',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'grid',
                    placeItems: 'center',
                    bgcolor: theme => theme.palette.primary.main,
                    borderRadius: '50%',
                    width: 24,
                    height: 24,
                  }}
                >
                  <Check
                    sx={{
                      fontSize: '1.25rem',
                      color: theme => theme.palette.common.white,
                    }}
                  />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography variant='body2'>
                    {entry.status_name}
                    {!!entry.tier && (
                      <Chip
                        size='small'
                        sx={{
                          ml: theme.spacing(1),
                          backgroundColor: 'lightGrey',
                          color: theme.palette.semiBlack.main,
                        }}
                        label={`${entry.tier}`}
                      />
                    )}
                  </Typography>

                  <Tooltip
                    disableHoverListener={!entry.cms_date}
                    disableFocusListener={!entry.cms_date}
                    title={
                      'CMS date: ' +
                      dayjs(entry.cms_date).format('MMM DD, YYYY')
                    }
                  >
                    <Typography
                      variant='body2'
                      sx={{ color: theme => theme.palette.semiBlack.main }}
                    >
                      {dayjs(entry.status_date).format('MMM DD, YYYY')}
                    </Typography>
                  </Tooltip>
                </Box>
              </Box>
              {entry.status_reason && (
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                  <Warning
                    color='error'
                    sx={{
                      fontSize: 16,
                      ml: 1,
                    }}
                  />
                  <Typography variant='caption' sx={{ color: 'error' }}>
                    {entry.status_reason}
                  </Typography>
                </Box>
              )}
              {index !== history.length - 1 && (
                <Divider
                  orientation='vertical'
                  sx={{
                    width: '.825rem',
                    borderRightWidth: '2px',
                    height: '1.5rem',
                    borderColor: theme => theme.palette.primary.main,
                  }}
                />
              )}
            </Box>
          );
        })
      )}
    </Box>
  );
};
